// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sdk-configurations{padding:16px;padding-top:24px;max-width:620px}.sdk-configurations-block{margin-bottom:36px}.sdk-configurations-title{font-size:18px;font-weight:600;margin-bottom:16px}.sdk-configurations-input{margin-bottom:24px}.sdk-configurations-checkbox-item{margin-bottom:24px}\n", ""]);
// Exports
module.exports = exports;
